import { render, staticRenderFns } from "./MlRegView.vue?vue&type=template&id=b8696128&scoped=true"
import script from "./MlRegView.vue?vue&type=script&lang=js"
export * from "./MlRegView.vue?vue&type=script&lang=js"
import style0 from "./MlRegView.vue?vue&type=style&index=0&id=b8696128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8696128",
  null
  
)

export default component.exports